import React from 'react';

import { Grid, Typography } from '@material-ui/core';

import { SelectField, Step } from '../SteppedForm';

const StepNetwork = (props) => {
  return (
    <Step
      id="network"
      title="Network"
      skip={() =>
        Object.keys(props.stateconfig().regions).length <= 1 &&
        Object.keys(props.stateconfig().regions[Object.keys(props.stateconfig().regions)[0]])
          .length <= 1 &&
        !props.networkconfig.tiger
      }>
      <Typography variant="body1" class="formQuestion">
        If a network does not appear as an option, it is not yet available in the region you have
        selected.
      </Typography>
      <Grid container>
        {props.state.formdata.state && props.stateconfig().regions ? (
          <Grid item xs={12} lg={6}>
            <SelectField
              id="region"
              label="Which region will you operate in?"
              values={Object.keys(props.stateconfig().regions)}
              required
            />
          </Grid>
        ) : (
          ''
        )}
        <Grid item xs={12} lg={6}>
          <SelectField
            id="network"
            label="Which network do you want to join?"
            values={props.getNetworks()}
            help="Please refer to the Frequently Asked Questions page. Note that 13cabs and Silver Service have specific requirements for Driver experience and Training / accreditation."
            required
          />
        </Grid>

      </Grid>
      
        <Typography style={{ textAlign: 'left' }}>
                      <b>
                        Please Note: You will not be able to log in to a Silver Service vehicle without your Silver Service Driver pin.<br/>
                        To avoid any delays, please make sure your pin is set up before you start.<br/>
                        If you do not have a Silver Service pin, please contact Partner Growth your local support hub or email the drivertraining@13cabs.com.au<br/>
                      </b>
        </Typography>
    </Step>
  );
};

export default StepNetwork;
